import React, { useState,useRef,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import "./Header.css";

const Header = ({darkBg=false}) => {
  const [menuState, setMenuState] = useState(false);
  const [changeArrowcolor, setChangeArrowColor] = useState(false);
  const [changeArrowcolorDec, setChangeArrowColorDec] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpenDesk, setIsDropdownOpenDesk] = useState(false);
  const [isDropdownOpenDec, setIsDropdownOpenDec] = useState(false);
  const [isDropdownOpenDeskDec, setIsDropdownOpenDeskDec] = useState(false);
  const [changeArrowcolorDes, setChangeArrowColorDes] = useState(false);
  const [isDropdownOpenDes, setIsDropdownOpenDes] = useState(false);
  const [isDropdownOpenDeskDes, setIsDropdownOpenDeskDes] = useState(false);
  const navigate = useNavigate()
  const clickCountRef = useRef(0);
  const dropdownRef = useRef();
  const dropdownRefDec = useRef();
  const dropdownRefDes = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && isDropdownOpenDesk) {
        if (!event.target.closest('.app')) {
          setIsDropdownOpenDesk(false);
        }
      }
      if (dropdownRefDec.current && !dropdownRefDec.current.contains(event.target) && isDropdownOpenDeskDec) {
        if (!event.target.closest('.app')) {
          setIsDropdownOpenDeskDec(false);
        }
      }
      if (dropdownRefDes.current && !dropdownRefDes.current.contains(event.target) && isDropdownOpenDeskDes) {
        if (!event.target.closest('.app')) {
          setIsDropdownOpenDeskDes(false);
        }
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isDropdownOpenDesk,isDropdownOpenDeskDec,isDropdownOpenDeskDes]);


const onClickService = (e) => {
    e.preventDefault();
    
      clickCountRef.current++;
      if (clickCountRef.current === 1) {
        setIsDropdownOpen(true);
      } 
      else if (clickCountRef.current === 2) {
        setMenuState(false)
        setIsDropdownOpen(false)
        navigate("/");
        clickCountRef.current = 0;
      }
  };
const onClickDec = (e) => {
    e.preventDefault();
    
      clickCountRef.current++;
      if (clickCountRef.current === 1) {
        setIsDropdownOpenDec(true);
      } 
      else if (clickCountRef.current === 2) {
        setMenuState(false)
        setIsDropdownOpenDec(false)
        navigate("/");
        clickCountRef.current = 0;
      }
  };
const onClickDes = (e) => {
    e.preventDefault();
    
      clickCountRef.current++;
      if (clickCountRef.current === 1) {
        setIsDropdownOpenDes(true);
      } 
      else if (clickCountRef.current === 2) {
        setMenuState(false)
        setIsDropdownOpenDes(false)
        navigate("/service");
        clickCountRef.current = 0;
      }
  };

  const menuClick = () => {
    setMenuState((prev) => !prev);
  };

  return (
    <div className={`header w-100`}
      style={darkBg ? {backgroundColor:"transparent"} : {}}
      
    >
      <div 
        className="header-wrapper container"
      >
        <nav className="navbar d-md-flex flex-md-row d-block">
          <nav className="navbar-container px-xl-0 px-2 py-2">
            <div className="nav-elements d-flex justify-content-between align-items-center px-xl-2" >
              <input className="d-none" type="checkbox" id="menu-toggle" />
              <img src={`/images/icons/nav-logo${darkBg ? "-b" : ""}.png`} className="nav-logo" onClick={()=>{navigate("/")}} style={{cursor:"pointer"}} alt='icon'/>
              <nav>
                <ul
                  className="nav-list d-xl-flex gap-xl-5 gap-lg-5 align-items-center d-none main-nav"
                  id="js-menu"
                >
               

                  <div className="navigation-dropdown" ref={dropdownRefDes}>
                  <li onMouseEnter={()=>{setIsDropdownOpenDeskDes(true);setIsDropdownOpenDesk(false)}} >

                      <div className="dropdown-trigger d-flex align-items-center" onMouseOver={()=>{setChangeArrowColorDes(true)}} onMouseOut={()=>{setChangeArrowColorDes(false)}}>
                          <Link to={"/service"} className={`nav-links font-lato ${darkBg && "color-dark"}`} onClick={()=>{setIsDropdownOpenDeskDes(false)}} style={{color:`${changeArrowcolorDes ? "#181818":"black"}`}}>Services</Link>
                          {/* <img src={`/images/icons/drop-icon-${darkBg ? "b":"w"}.png`} className={isDropdownOpenDeskDes ? "rotate-icon arrow-icon":"rotate-back arrow-icon" }  alt='icon'/> */}
                      </div>
                      {/* <div className={`dropdown-content ${isDropdownOpenDeskDes ? 'open' : 'none-delay'}`} onMouseEnter={()=>{setIsDropdownOpenDeskDes(true)}} onMouseLeave={()=>{setIsDropdownOpenDeskDes(false)}} style={{left:"0px"}}>
              
                        <Link to={"/"} className={`nav-links font-lato ${darkBg && "color-dark"}`} onClick={()=>{setIsDropdownOpenDeskDes(false)}}>
                          <p className="mb-0" >Membership</p>
                        </Link>
                     
                      </div> */}
                    </li>
                    </div>
                    
                  {/* <li>
                    <Link to={"/"} className={`nav-links font-lato ${darkBg && "color-dark"}`}>
                      What We Do
                    </Link>
                  </li>
                  <li>
                    <Link to={"/team"} className={`nav-links font-lato ${darkBg && "color-dark"}`}>
                      Our Team
                    </Link>
                  </li> */}

                  <div className="navigation-dropdown">
                  <li onMouseEnter={()=>{setIsDropdownOpenDeskDes(true);setIsDropdownOpenDeskDec(false)}} >

                      <div className="dropdown-trigger d-flex align-items-center" onMouseOver={()=>{setChangeArrowColor(true)}} onMouseOut={()=>{setChangeArrowColor(false)}}>
                          <Link to={""} className={`nav-links font-lato ${darkBg && "color-dark"}`} onClick={()=>{setIsDropdownOpenDeskDes(false)}} style={{color:`${changeArrowcolor ? "#181818":"black"}`}}>About the Clinic</Link>
                          
                      </div>
                      {/* <div className={`dropdown-content ${isDropdownOpenDesk ? 'open' : 'none-delay'}`} onMouseEnter={()=>{setIsDropdownOpenDesk(true)}} onMouseLeave={()=>{setIsDropdownOpenDesk(false)}}>
              
                        <Link to={"/"} className={`nav-links font-lato ${darkBg && "color-dark"}`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-0">Services</p>
                        </Link>
                       
                      </div> */}
                    </li>
                    </div>
                  <div className="navigation-dropdown" ref={dropdownRef}>
                  <li onMouseEnter={()=>{setIsDropdownOpenDeskDes(true);setIsDropdownOpenDeskDec(false)}} >

                      <div className="dropdown-trigger d-flex align-items-center" onMouseOver={()=>{setChangeArrowColor(true)}} onMouseOut={()=>{setChangeArrowColor(false)}}>
                          <Link to={"/article-main"} className={`nav-links font-lato ${darkBg && "color-dark"}`} onClick={()=>{setIsDropdownOpenDeskDes(false)}} style={{color:`${changeArrowcolor ? "#181818":"black"}`}}>Articles</Link>
                          {/* <img src={`/images/icons/drop-icon-${darkBg ? "b":"w"}.png`} className={isDropdownOpenDeskDes ? "rotate-icon arrow-icon":"rotate-back arrow-icon" } alt='icon'/> */}
                      </div>
                      {/* <div className={`dropdown-content ${isDropdownOpenDesk ? 'open' : 'none-delay'}`} onMouseEnter={()=>{setIsDropdownOpenDesk(true)}} onMouseLeave={()=>{setIsDropdownOpenDesk(false)}}>
              
                        <Link to={"/"} className={`nav-links font-lato ${darkBg && "color-dark"}`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-0">Services</p>
                        </Link>
                       
                      </div> */}
                    </li>
                    </div>
                  <li  >

                      <div className="d-flex align-items-center" >
                          <Link to={"/contact"} className={`nav-links font-lato ${darkBg && "color-dark"}`} onClick={()=>{setIsDropdownOpenDeskDes(false)}} style={{color:`${changeArrowcolor ? "#181818":"black"}`}}>Contact</Link>
                      </div>
                     
                    </li>
                 
                
                </ul>
              </nav>

              <label
                value="menu-toggle"
                onClick={menuClick}
                className="responsive-menu-btn d-xl-none d-inline"
              >
                <img
                  src={`/images/icons/hamburger-menu-b.png`}
                  className="img-fluid menu-btn"
                  alt="menu"
                />
              </label>

             

              <div className="nav-buttton ml-5 d-xl-flex d-none gap-3 extras-btns">
                {/* <a href='tel:905-841-9879' style={{textDecoration:"none"}}></a> */}
                  <button 
                  className={`genral-btn-narrow`}
                  onClick={()=>{navigate("/membership")}} 
                  >
                    Explore membership
                  </button>
              </div>
            </div>
            {/* New DropDown */}
               <div className={`${isDropdownOpenDeskDes ? 'open' : 'none-delay'} w-100 mt-3 whole-width-Dropdown `} style={{position:"absolute",borderBottomLeftRadius:"15px",borderBottomRightRadius:"15px",background:"#00000069",backdropFilter: "blur(15px)"}} onMouseEnter={()=>{setIsDropdownOpenDeskDes(true)}} onMouseLeave={()=>{setIsDropdownOpenDeskDes(false)}}>
                <div className="container-fluid ps-4 d-xl-block d-none">
                  <div className="row ">
                    <div className="col-lg-2 pt-4 px-0 ps-3 pt-xxl-5">
                      <h3 className="color-light pb-4 pt-2" style={{fontWeight:"600",fontSize:"1.3rem"}} >Services</h3>
                      
                        {/* <Link to={"/"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Executive Membership</p>
                        </Link> */}
                        <Link to={"/dna-clinical-testing"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">DNA Clinical Testing</p>
                        </Link>
                        {/* <Link to={"/mens"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Pelvic Floor Men</p>
                        </Link>
                        <Link to={"/women"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Pelvic Floor Women</p>
                        </Link> */}
                        {/* <Link to={"/ed-treatment"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">ED Treatment</p>
                        </Link> */}
                        <Link to={"/iv-therapy-boost-shots"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">IV therapy</p>
                        </Link>
                        {/* <Link to={"/naturopathic-medicine"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Naturopathic Medicine</p>
                        </Link>
                        <Link to={"/audiology"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Audiology</p>
                        </Link>
                        <Link to={"/sports-medicine"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Sports Medicine</p>
                        </Link>
                        <Link to={"/orthopaedic-clinic"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Orthopaedic Clinic</p>
                        </Link>
                        <Link to={"/gyno-uro-clinic"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Gyno-uro Clinic</p>
                        </Link>
                        
                        <Link to={"/medical-aesthetics"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Medical Aesthetics</p>
                        </Link>
                        <Link to={"/aging-wellness-clinic"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Aging Wellness Clinic</p>
                        </Link>
                        <Link to={"/geriatric-health-assessment-program"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Geriatric Health Assessment Program</p>
                        </Link>
                        <Link to={"/global-medical-consulting"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Global Medical Consulting</p>
                        </Link> */}
                        {/* <Link to={"/mens"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">For men</p>
                        </Link>
                        <Link to={"/women"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">For women</p>
                        </Link>  */}
                       <Link to={"/service"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3 `} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-5 pt-4 ">All services</p>
                        </Link>
                       
                    </div>
                        <div className="col-lg-1 col-0  d-flex align-items-center justify-content-center pt-xxl-4" style={{height:'auto'}}> <div className="borderedLine"></div></div>
                    <div className="col-lg-2 pt-4 px-0 pt-xxl-5">
                      <h3 className="color-light pb-4 pt-2" style={{fontWeight:"600",fontSize:"1.3rem"}}>About The Clinic</h3>
                      
                        <Link to={"/membership"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3 `} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Executive Membership</p>
                        </Link>
                        <Link to={"/team"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3 `} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Meet the team</p>
                        </Link>
                        
                        {/* <Link to={"/"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3 `} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Testimonials</p>
                        </Link> */}
                        {/* <Link to={"/mens"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">For Mens</p>
                        </Link>
                        <Link to={"/women"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">For Women</p>
                        </Link> */}
                    </div>
                    <div className="col-lg-1 col-0  d-flex align-items-center justify-content-center pt-xxl-4" style={{height:'auto'}} > <div className="borderedLine"></div></div>
                    <div className="col-lg-3 pt-4 px-0 pt-xxl-5">
                      <h3 className="color-light pb-4 pt-2" style={{fontWeight:"600",fontSize:"1.3rem"}}>Articles</h3>
                      
                        <Link to={"/article/what-does-prevention-actually-look-like-after-40"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3 `} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">What Does Prevention Look Like</p>
                        </Link>
                        <Link to={"/article/how-stress-and-burnout-affect-long-term-health"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">How Stress & Burnout Affect Health</p>
                        </Link>
                        <Link to={"/article/your-metabolism-isnt-broken-its-misunderstood"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Your Metabolism Isn’t Broken</p>
                        </Link>
                        <Link to={"/article/the-executive-health-exam-why-one-day-can-change-your-year"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">The Executive Health Exam</p>
                        </Link>
                        <Link to={"/article/womens-health-after-40-what-should-change"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3`} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-2">Womens Health After 40</p>
                        </Link>
                         <Link to={"/article-main"} className={`nav-links font-lato ${darkBg && "color-dark"} pb-3 `} onClick={()=>{setIsDropdownOpenDesk(false)}}>
                          <p className="mb-5 pt-4 ">All articles</p>
                        </Link>
                    </div>
                        
                    <div className="col-lg-3 p-4 pt-xxl-5" style={{background:"#FAF7EE",borderBottomLeftRadius:"15px",borderBottomRightRadius:"15px"}}>
                        <h3 className=" mt-2" style={{fontWeight:"800",fontSize:"1rem",color:"black"}}>Start Your Healthy Journey</h3>
                          <p className="my-3">Speak with our team to explore how our executive care model supports your long-term wellness.</p>
                          <button 
                          className={`genral-btn-narrow mt-3`}
                          onClick={()=>{navigate("/membership")}} 
                          >
                            Explore membership
                          </button>
                    </div>
                  </div>
                </div>
              </div>
          </nav>

          {/* Dropdown in responsive mode */}
          <nav className="responsive-popup-menu w-100">
            <div className="py-3 d-xl-none" style={{ display: menuState ? "block" : "none" }}>
            <ul
              className="resp-nav-list d-xl-none w-100 gap-4 hs-dropdown [--trigger:hover] pl-4"
              style={{ display: menuState ? "block" : "none" }}
            >
              <li>
                <Link to={"/membership"} className={`nav-links font-lato ${darkBg && "color-dark"}`}>
                Membership
                </Link>
              </li>
              <li>
                <Link to={"/"} className={`nav-links font-lato ${darkBg && "color-dark"}`}>
                What We Do
                </Link>
              </li>
               {/* <li>
                <div className="navigation-dropdown">
                  <div className="dropdown-trigger d-flex align-items-center" style={{color:"black"}} onClick={onClickService} >
                      <a className={`nav-links font-lato ${darkBg && "color-dark"}`} >STAGING</a>
                      <img src='/images/icons/drop-icon-b.png' className={isDropdownOpen ? "rotate-icon arrow-icon":"rotate-back arrow-icon" } alt='icon'/>
                  </div>
                  <div className={`dropdown-content ${isDropdownOpen ? 'open' : 'd-none'}`} style={{top:"85%",left:"0%"}}>
                    
                    <Link to={"/staging-home-owner"} className={`nav-links font-lato ${darkBg && "color-dark"}`} onClick={()=>{setIsDropdownOpen(false); setMenuState(false)}}>
                      <p className="mb-0">HOME OWNER</p>
                    </Link>
                    <Link to={"/staging-realtors"} className={`nav-links font-lato ${darkBg && "color-dark"}`} onClick={()=>{setIsDropdownOpen(false); setMenuState(false)}}>
                      <p className="mb-0">REALTORS</p>
                    </Link>
                    <Link to={"/staging-builders"} className={`nav-links font-lato ${darkBg && "color-dark"}`} onClick={()=>{setIsDropdownOpen(false); setMenuState(false)}}>
                      <p className="mb-0">BUILDERS</p>
                    </Link>
                   
                    <Link to={"/decorating-organizing"} className={`nav-links font-lato ${darkBg && "color-dark"}`} onClick={()=>{setIsDropdownOpenDec(false); setMenuState(false)}}>
                      <p className="mb-0">ADDITIONAL SERVICES</p>
                    </Link>
                    
                  </div>
                </div>
                </li> */}
             
               <li>
                <div className="navigation-dropdown">
                  <div className="dropdown-trigger d-flex align-items-center" style={{color:"black"}} onClick={onClickDes} >
                      <a className={`nav-links font-lato ${darkBg && "color-dark"}`} >Services</a>
                      <img src='/images/icons/drop-icon-b.png' className={isDropdownOpenDes ? "rotate-icon arrow-icon":"rotate-back arrow-icon" } alt='icon' style={{filter:"invert(0)"}}/>
                  </div>
                  <div className={`dropdown-content ${isDropdownOpenDes ? 'open' : 'd-none'}`} style={{top:"85%",left:"0%"}}>
                    
                    
                  
                    <Link to={"/iv-therapy-boost-shots"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">IV Therapy</p>
                        </Link>
                        <Link to={"/dna-clinical-testing"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">DNA Clinical Testing</p>
                        </Link>
                        <Link to={"/naturopathic-medicine"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Naturopathic Medicine</p>
                        </Link>
                        <Link to={"/audiology"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Audiology</p>
                        </Link>
                        <Link to={"/sports-medicine"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Sports Medicine</p>
                        </Link>
                        <Link to={"/orthopaedic-clinic"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Orthopaedic Clinic</p>
                        </Link>
                        {/* <Link to={"/gyno-uro-clinic"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Gyno-uro Clinic</p>
                        </Link> */}
                        {/* <Link to={"/pelvic-floor-therapy"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Pelvic Floor Therapy</p>
                        </Link> */}
                        {/* <Link to={"/mens"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Pelvic Floor Mens</p>
                        </Link> */}
                        <Link to={"/women"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Pelvic Floor Women</p>
                        </Link>
                        <Link to={"/medical-aesthetics"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Medical Aesthetics</p>
                        </Link>
                        <Link to={"/aging-wellness-clinic"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Aging Wellness Clinic</p>
                        </Link>
                        <Link to={"/geriatric-health-assessment-program"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Geriatric Health Assessment Program</p>
                        </Link>
                        <Link to={"/global-medical-consulting"} className={`nav-links font-lato ${darkBg && "color-dark"} `} onClick={()=>{setIsDropdownOpenDes(false); setMenuState(false)}}>
                          <p className="mb-2">Global Medical Consulting</p>
                        </Link>
                    
                  </div>
                </div>
                </li>

              
              <li>
                <Link to={"/team"} className={`nav-links font-lato ${darkBg && "color-dark"}`}>
                Our Team
                </Link>
              </li>
              <li>
                <Link to={"/contact"} className={`nav-links font-lato ${darkBg && "color-dark"}`}>
                Contact
                </Link>
              </li>
              
            </ul>
            <div className="nav-buttton flex-wrap d-flex gap-4 extras-btns">
              {/* <a href='tel:905-841-9879' style={{textDecoration:"none"}}></a> */}
                <button 
                className="genral-btn-narrow font-lato" 
                onClick={()=>{navigate("/membership")}} 
                >
                   Explore membership
                </button>
            </div>
            </div>
          </nav>
        </nav>
      </div>
    </div>
  );
};

export default Header; 